/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import ScrollMenu from 'react-horizontal-scrolling-menu';

//import StepItem from '../../components/StepItem'

class TvInfo extends PureComponent {
  state = {
    left: false,
    right: true,
    nextLiveInfo: [],
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    const { contentSerial } = this.props.childProps;
    this._getData(contentSerial);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getData = async (contentSerial) => {
    const { existTv } = this.props.childProps;
    const result = await this._getDataApi(contentSerial);
    const intReturn = result.data[0].intReturn;
    const str = result.data[0].str;
    const nextLiveInfo = result.data[0].listData;

    //console.log(str)
    //console.log(nextLiveInfo)

    if (this._isMounted) {
      if (intReturn === 0) {
        this.setState({
          str,
          nextLiveInfo,
        });
      } else {
        this.setState({
          str,
        });
      }

      ////console.log(str, intReturn)
      if (str !== '') {
        if (intReturn === 0) {
          existTv(true);
        } else {
          existTv(true);
        }
      } else {
        if (intReturn === 0) {
          existTv(true);
        } else {
          existTv(false);
        }
      }
      /*
            if(str !== '' && intReturn !== 0) {
                existTv(true)
            } else {
                existTv(false)
            }
            */
    }
  };

  _getDataApi = (contentSerial) => {
    const { apiUrl } = this.props;
    return axios
      .post(apiUrl + '/contentTvInfo', {
        params: {
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };

  _renderItem = () => {
    const { nextLiveInfo } = this.state;

    const list = nextLiveInfo.map((item, index) => {
      return (
        <li key={index}>
          <div>
            <p className="date">
              {item.mm}.{item.dd} ({item.weekName}) {item.startTime}
            </p>
            <p className="epi">{item.subTitle}</p>
          </div>
        </li>
      );
    });

    return list;
  };
  _onFirst = () => {
    this.setState({
      left: false,
      right: true,
    });
  };
  _onLast = () => {
    this.setState({
      right: false,
      left: true,
    });
  };
  render() {
    const { str, nextLiveInfo, left, right } = this.state;
    const { imgUrl } = this.props;

    return (
      <Fragment>
        <div className="info">
          <div className="live active">
            <dl>
              <dt>본방</dt>
              <dd>
                {/*<button type="button" className="btn_bell" title="알림">알림</button>*/}
                {str}
                {/*매주(금) 23:30 - 25화 달 아래에서, 엉터리 댄스를*/}
              </dd>
            </dl>
          </div>

          <div className="timeline">
            <dl>
              <dt>재방</dt>
              <dd>
                <ul className="list">
                  {nextLiveInfo ? (
                    <ScrollMenu
                      data={nextLiveInfo ? this._renderItem() : null}
                      arrowLeft={
                        left ? (
                          <div className="btn_prev">
                            <img src={imgUrl + '/img/live_img/arrow_lt.png'} />
                          </div>
                        ) : null
                      }
                      arrowRight={
                        right ? (
                          <div className="btn_next">
                            <img src={imgUrl + '/img/live_img/arrow_rt.png'} />
                          </div>
                        ) : null
                      }
                      wheel={false}
                      dragging={true}
                      transition={0.5}
                      translate={0}
                      alignOnResize={true}
                      //inertiaScrolling={true}
                      //inertiaScrollingSlowdown={3}
                      //wrapperStyle={{border: 0, backgroundColor: '#fff'}}
                      itemStyle={{
                        borderLeftStyle: 'inset',
                        borderLeftWidth: 1,
                        borderLeftColor: '#888',
                      }}
                      alignCenter={false}
                      hideSingleArrow={true}
                      hideArrows={false}
                      onFirstItemVisible={this._onFirst}
                      onLastItemVisible={this._onLast}
                    />
                  ) : null}
                </ul>
              </dd>
            </dl>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(TvInfo)));
